import { groupBy } from 'lodash';

const getProductByType = (products, productType) => {
  let grouped = groupBy(products, 'Product.MultiNetworkID');

  let prods = [];

  for (const key of Object.keys(grouped)) {
    let groupedBuyups = grouped[key];
    if (!key || key === '' || key === 'null') {
      for (let prod of groupedBuyups) {
        prods.push(prod);
      }
    } else {
      let tempProd = {};
      for (let prod of groupedBuyups) {
        if (prod.Product.MultiNetworkCategory === 'core') {
          tempProd = prod;
        }
      }

      for (let prod of groupedBuyups) {
        if (prod.Product.MultiNetworkCategory === 'buyup') {
          tempProd.buyup = prod;
          tempProd.buyup.Suggested = false;
        }
      }

      prods.push(tempProd);
    }
  }

  for (let product of prods) {
    if (product.Product) {
      if (product.Product.Type === productType) {
        product.Product.Business = product.Provider;
        if (product.buyup && product.buyup.Product && product.buyup.Provider) {
          product.buyup.Product.Business = product.buyup.Provider;
        }
        return product;
      }
    }
  }

  return null;
};

export function formatPhoneNumber(phoneNumberString) {
  var cleaned = ('' + phoneNumberString).replace(/\D/g, '');
  var match = cleaned.match(/^(1|)?(\d{3})(\d{3})(\d{4})$/);
  if (match) {
    var intlCode = match[1] ? '+1 ' : '';
    return [intlCode, '(', match[2], ') ', match[3], '-', match[4]].join('');
  }
  return null;
}

const getContactInfo = ({ page }) => {
  const { ContactInfo = {}, EnrollmentURL = '' } = page;
  if (ContactInfo.Email || ContactInfo.PhoneNumber || ContactInfo.Description) {
    let phone = ContactInfo.PhoneNumber;
    if (phone) {
      phone = formatPhoneNumber(phone);
    }
    return `
      <div style="width: 100%;" >

        <div style="display: flex; justify-content: space-between; align-items: center;">
          <h2>Contact Information</h2>
          ${
            EnrollmentURL &&
            `
            <a href="${EnrollmentURL}" style="display: flex; align-items: center; margin: auto; margin-right: 0; border-radius: 8px; color: white; font-weight: bold; background-color: black; border: none; padding: 0; text-decoration: none;">
              <span style="padding: 8px;">Enroll</span>
            </a>
          `
          }
        </div>

        ${ContactInfo.Description && `<div style="margin: 0 32px;">${ContactInfo.Description}</div>`}

        <div style="display: flex;">
          ${
            ContactInfo.Email &&
            `
            <div style="margin: 8px auto;">
              <div style="font-weight: bold;">Email</div>
              <div>${ContactInfo.Email}</div>
            </div>
          `
          }
          <br />
          ${
            phone &&
            `
            <div style="margin: 8px auto;">
              <div style="font-weight: bold;">Phone</div>
              <div>${phone}</div>
            </div>
          `
          }
        </div>

      </div>
    `;
  } else {
    return '';
  }
};

const getMedicalPlanEmailTemplate = (emailProps) => {
  if (
    emailProps.emailRecList.healthcareGov ||
    emailProps.emailRecList.referenceBasedPricing ||
    emailProps.emailRecList.medicare ||
    emailProps.emailRecList.medicalPlan
  ) {
    return `<div>
    <h2>Medical</h2>
    ${getMedicalPlanTempate(emailProps)}
    ${getSavingsAccountTemplate(emailProps)}
    </div>`;
  } else {
    return '';
  }
};

const getSavingsAccountTemplate = ({ emailRecList, emailProducts }) => {
  let accountTemplate = '<div>';
  if (emailRecList.hsa || emailRecList.fsa || emailRecList.dependentCareFSA || emailRecList.limitedPurposeFSA) {
    accountTemplate += `<h2>Pre-Tax Accounts To Pair With Your Medical Plan</h2>`;
  }

  if (emailRecList.hsa) {
    let logo = '';

    if (
      getProductByType(emailProducts, 'hsa_buyup') &&
      getProductByType(emailProducts, 'hsa_buyup').Product.Business &&
      getProductByType(emailProducts, 'hsa_buyup').Product.Business.LogoURL
    ) {
      logo = getProductByType(emailProducts, 'hsa_buyup').Product.Business.LogoURL;
    }
    accountTemplate += benefitTemplate('Health Savings Account', '', logo);
  }
  if (emailRecList.fsa) {
    let logo = '';

    if (
      getProductByType(emailProducts, 'fsa_buyup') &&
      getProductByType(emailProducts, 'hsa_buyup').Product.Business &&
      getProductByType(emailProducts, 'hsa_buyup').Product.Business.LogoURL
    ) {
      logo = getProductByType(emailProducts, 'hsa_buyup').Product.Business.LogoURL;
    }
    accountTemplate += benefitTemplate('Flexible Spending Account', '', logo);
  }
  if (emailRecList.dependentCareFSA) {
    let logo = '';

    if (
      getProductByType(emailProducts, 'dependant_care_fsa_buyup') &&
      getProductByType(emailProducts, 'dependant_care_fsa_buyup').Product.Business &&
      getProductByType(emailProducts, 'dependant_care_fsa_buyup').Product.Business.LogoURL
    ) {
      logo = getProductByType(emailProducts, 'dependant_care_fsa_buyup').Product.Business.LogoURL;
    }
    accountTemplate += benefitTemplate('Dependent Care FSA', '', logo);
  }
  if (emailRecList.limitedPurposeFSA) {
    let logo = '';

    if (
      getProductByType(emailProducts, 'limited_fsa_buyup') &&
      getProductByType(emailProducts, 'limited_fsa_buyup').Product.Business &&
      getProductByType(emailProducts, 'limited_fsa_buyup').Product.Business.LogoURL
    ) {
      logo = getProductByType(emailProducts, 'limited_fsa_buyup').Product.Business.LogoURL;
    }
    accountTemplate += benefitTemplate('Limited Purpose FSA', '', logo);
  }

  accountTemplate += '</div>';
  return accountTemplate;
};

const getMedicalPlanTempate = ({ emailRecList, emailProducts }) => {
  if (emailRecList.healthcareGov || emailRecList.medicare || emailRecList.referenceBasedPricing) {
    if (emailRecList.healthcareGov) {
      return `
      <div style="border-radius: 10px; border: 1px solid #9c9c9c; margin: 14px;">
                <div style=" display: flex; justify-content: space-between; padding: 14px; align-items: center;">
                  <div style="display: flex; flex-direction: column; align-items: flex-start;" >
                    <div style="font-weight: bold; padding: 8px; color: #000; font-size: 14px;  text-align: left;">
                      Individual Plan through Healthcare.gov
                    </div>
                  </div>
                </div>
  
                <div style="padding: 14px; padding-top: 0px; font-size: 14px;">${
                  getProductByType(emailProducts, 'healthcaregov').Product.CardText
                }</div>
                <div style="padding: 14px; padding-top: 0px; font-weight: bold; color: #000;">Connect with an Advisor</div>
                <div style="padding-left: 14px; padding-right: 14px; padding-bottom: 14px;">${
                  getProductByType(emailProducts, 'healthcaregov').Product.AdvisorPhone
                }</div>
              </div>`;
    }
    if (emailRecList.medicare) {
      return `
      <div style="border-radius: 10px; border: 1px solid #9c9c9c; margin: 14px;">
                <div style=" display: flex; justify-content: space-between; padding: 14px; align-items: center;">
                  <div style="display: flex; flex-direction: column; align-items: flex-start;" >
                    <div style="font-weight: bold; padding: 8px; color: #000; font-size: 14px;  text-align: left;">
                      Medicare
                    </div>
                  </div>
                </div>
  
                <div style="padding: 14px; padding-top: 0px; font-size: 14px;">${
                  getProductByType(emailProducts, 'medicare_recommendation').Product.CardText
                }</div>
                <div style="padding: 14px; padding-top: 0px; font-weight: bold; color: #000;">Connect with an Advisor</div>
                <div style="padding-left: 14px; padding-right: 14px; padding-bottom: 14px;">${
                  getProductByType(emailProducts, 'medicare_recommendation').Product.AdvisorPhone
                }</div>
              </div>`;
    }
    if (emailRecList.referenceBasedPricing) {
      return `
      <div style="border-radius: 10px; border: 1px solid #9c9c9c; margin: 14px;">
                <div style=" display: flex; justify-content: space-between; padding: 14px; align-items: center;">
                  <div style="display: flex; flex-direction: column; align-items: flex-start;" >
                    <div style="font-weight: bold; padding: 8px; color: #000; font-size: 14px;  text-align: left;">
                    Reference Based Pricing. A new type of Health Plan
                    </div>
                  </div>
                </div>
  
                <div style="padding: 14px; padding-top: 0px; font-size: 14px;">${
                  getProductByType(emailProducts, 'reference_based_pricing').Product.CardText
                }</div>
                <div style="padding: 14px; padding-top: 0px; font-weight: bold; color: #000;">Connect with an Advisor</div>
                <div style="padding-left: 14px; padding-right: 14px; padding-bottom: 14px;">${
                  getProductByType(emailProducts, 'reference_based_pricing').Product.AdvisorPhone
                }</div>
              </div>`;
    }
  } else {
    let logo = '';
    let buyupLogo = '';
    let hasBuyup = false;
    let hasNarrow = false;
    let narrowLogo = '';
    let buyupName = '';
    let narrowName = '';

    if (emailRecList.medicalPlan && emailRecList.medicalPlan.Business && emailRecList.medicalPlan.Business.LogoURL) {
      logo = emailRecList.medicalPlan.Business.LogoURL;
    }

    if (emailRecList.medicalPlan && emailRecList.medicalPlan.Plan && emailRecList.medicalPlan.Plan.buyUpNetwork) {
      if (
        emailRecList.medicalPlan.Plan.buyUpNetwork.Business &&
        emailRecList.medicalPlan.Plan.buyUpNetwork.Business.LogoURL
      ) {
        buyupLogo = emailRecList.medicalPlan.Plan.buyUpNetwork.Business.LogoURL;
      }
      if (
        emailRecList.medicalPlan.Plan.buyUpNetwork.Plan &&
        emailRecList.medicalPlan.Plan.buyUpNetwork.Plan.NetworkInformation
      ) {
        buyupName = emailRecList.medicalPlan.Plan.buyUpNetwork.Plan.NetworkInformation.Name;
      }

      hasBuyup = true;
    }

    if (emailRecList.medicalPlan && emailRecList.medicalPlan.Plan && emailRecList.medicalPlan.Plan.narrowNetwork) {
      if (
        emailRecList.medicalPlan.Plan.narrowNetwork.Business &&
        emailRecList.medicalPlan.Plan.narrowNetwork.Business.LogoURL
      ) {
        narrowLogo = emailRecList.medicalPlan.Plan.narrowNetwork.Business.LogoURL;
      }
      if (
        emailRecList.medicalPlan.Plan.narrowNetwork.Plan &&
        emailRecList.medicalPlan.Plan.narrowNetwork.Plan.NetworkInformation
      ) {
        narrowName = emailRecList.medicalPlan.Plan.narrowNetwork.Plan.NetworkInformation.Name;
      }

      hasNarrow = true;
    }

    return benefitTemplate(
      emailRecList.medicalPlan.Plan.Name,
      '',
      logo,
      false,
      '',
      hasBuyup,
      hasNarrow,
      narrowLogo,
      buyupLogo,
      buyupName,
      narrowName,
      hasBuyup || hasNarrow ? 'Core Network' : ''
    );
  }
};

const benefitTemplate = (
  name,
  carrierName,
  carrierLogo,
  link,
  linkText,
  hasBuyup = false,
  hasNarrow = false,
  narrowLogo = '',
  buyupLogo = '',
  buyupName = '',
  narrowName = '',
  coreName = ''
) => {
  return `<div style="border-radius: 10px; border: 1px solid #9c9c9c; margin: 14px; ">
  ${
    coreName
      ? ` <div style="font-weight: bold; padding: 14px; color: #000; font-size: 18px;  text-align: left;">
  ${name}

</div>`
      : ``
  }
  ${
    hasBuyup || hasNarrow
      ? ` <div style="font-weight: bold; padding: 14px; color: #000; font-size: 14px; text-align: center; line-height: 20px;">
      There are multiple options available. Select the one that works for you!
  </div>`
      : ''
  }

  <div style=" display: flex; justify-content: space-between; padding: 14px;  align-items: center;">
    <div>
    ${
      carrierLogo
        ? `<div style="font-weight: 400; font-size: 12px; padding-left: 8px;"><img style="max-height: 40px; max-width: 100px;" src="${carrierLogo}" /></div>`
        : ''
    }
      <div style="font-weight: bold; padding: 8px; color: #000; font-size: 14px;  text-align: left;">
        ${coreName ? coreName : name}

      </div>
      ${
        carrierName && !carrierLogo
          ? `<div style="font-weight: 400; font-size: 12px; padding-left: 8px;">through ${carrierName}</div>`
          : ''
      }
    </div>

    ${link && linkText ? `<div><a href="${link}">${linkText}</a></div>` : ''}

   
  </div>



  ${
    hasBuyup
      ? `<div style="padding: 14px;">
     

      <div>
      ${
        buyupLogo
          ? `<div style="font-weight: 400; font-size: 12px; padding-left: 8px;"><img style="max-height: 40px; max-width: 100px;" src="${buyupLogo}" /></div>`
          : ''
      }
        <div style="font-weight: bold; padding: 8px; color: #000; font-size: 14px;  text-align: left;">
          ${buyupName}
  
        </div>
      </div>


  </div>`
      : ''
  }

  ${
    hasNarrow
      ? `<div style="padding: 14px;">
     

      <div>
      ${
        narrowLogo
          ? `<div style="font-weight: 400; font-size: 12px; padding-left: 8px;"><img style="max-height: 40px; max-width: 100px;" src="${narrowLogo}" /></div>`
          : ''
      }
        <div style="font-weight: bold; padding: 8px; color: #000; font-size: 14px;  text-align: left;">
          ${narrowName}
  
        </div>
      </div>


  </div>`
      : ''
  }
</div>`;
};

const getCoreBenefitTemplate = ({ emailRecList, emailProducts }) => {
  let accountTemplate = '<div>';
  if (
    emailRecList.vision ||
    emailRecList.dental ||
    emailRecList.dentalOrtho ||
    emailRecList.shortTerm ||
    emailRecList.longTerm ||
    emailRecList.suppLife
  ) {
    accountTemplate += `<h2>Valuable Core Benefits</h2>`;
  }

  if (emailRecList.vision) {
    let carrierLogo = '';
    let carrierName = getProductByType(emailProducts, 'vision_buyup').Product.Carrier;
    if (
      getProductByType(emailProducts, 'vision_buyup').Product.Business &&
      getProductByType(emailProducts, 'vision_buyup').Product.Business.Name
    ) {
      carrierName = getProductByType(emailProducts, 'vision_buyup').Product.Business.Name;
    }
    if (
      getProductByType(emailProducts, 'vision_buyup').Product.Business &&
      getProductByType(emailProducts, 'vision_buyup').Product.Business.LogoURL
    ) {
      carrierLogo = getProductByType(emailProducts, 'vision_buyup').Product.Business.LogoURL;
    }

    let buyupLogo = '';
    let buyupName = '';
    let hasBuyup = false;
    let coreName = '';
    if (getProductByType(emailProducts, 'vision_buyup').buyup) {
      hasBuyup = true;
      if (
        getProductByType(emailProducts, 'vision_buyup').buyup.Product &&
        getProductByType(emailProducts, 'vision_buyup').buyup.Product.PlanName
      ) {
        buyupName = getProductByType(emailProducts, 'vision_buyup').buyup.Product.PlanName;
      }

      if (
        getProductByType(emailProducts, 'vision_buyup').Product &&
        getProductByType(emailProducts, 'vision_buyup').Product.PlanName
      ) {
        coreName = getProductByType(emailProducts, 'vision_buyup').Product.PlanName;
      }

      if (
        getProductByType(emailProducts, 'vision_buyup').buyup.Product.Business &&
        getProductByType(emailProducts, 'vision_buyup').buyup.Product.Business.LogoURL
      ) {
        buyupLogo = getProductByType(emailProducts, 'vision_buyup').buyup.Product.Business.LogoURL;
      }
    }

    accountTemplate += benefitTemplate(
      'Vision',
      carrierName,
      carrierLogo,
      false,
      '',
      hasBuyup,
      false,
      '',
      buyupLogo,
      buyupName,
      '',
      coreName
    );
  }
  if (emailRecList.dental) {
    let carrierLogo = '';
    let carrierName = getProductByType(emailProducts, 'dental_buyup').Product.Carrier;
    if (
      getProductByType(emailProducts, 'dental_buyup').Product.Business &&
      getProductByType(emailProducts, 'dental_buyup').Product.Business.Name
    ) {
      carrierName = getProductByType(emailProducts, 'dental_buyup').Product.Business.Name;
    }
    if (
      getProductByType(emailProducts, 'dental_buyup').Product.Business &&
      getProductByType(emailProducts, 'dental_buyup').Product.Business.LogoURL
    ) {
      carrierLogo = getProductByType(emailProducts, 'dental_buyup').Product.Business.LogoURL;
    }

    let buyupLogo = '';
    let buyupName = '';
    let hasBuyup = false;
    let coreName = '';
    if (getProductByType(emailProducts, 'dental_buyup').buyup) {
      hasBuyup = true;
      if (
        getProductByType(emailProducts, 'dental_buyup').buyup.Product &&
        getProductByType(emailProducts, 'dental_buyup').buyup.Product.ProductName
      ) {
        buyupName = getProductByType(emailProducts, 'dental_buyup').buyup.Product.ProductName;
      }

      if (
        getProductByType(emailProducts, 'dental_buyup').Product &&
        getProductByType(emailProducts, 'dental_buyup').Product.ProductName
      ) {
        coreName = getProductByType(emailProducts, 'dental_buyup').Product.ProductName;
      }

      if (
        getProductByType(emailProducts, 'dental_buyup').buyup.Product.Business &&
        getProductByType(emailProducts, 'dental_buyup').buyup.Product.Business.LogoURL
      ) {
        buyupLogo = getProductByType(emailProducts, 'dental_buyup').buyup.Product.Business.LogoURL;
      }
    }
    accountTemplate += benefitTemplate(
      'Dental',
      carrierName,
      carrierLogo,
      false,
      '',
      hasBuyup,
      false,
      '',
      buyupLogo,
      buyupName,
      '',
      coreName
    );
  }
  if (emailRecList.dentalOrtho) {
    let carrierLogo = '';
    let carrierName = getProductByType(emailProducts, 'dental_ortho_buyup').Product.Carrier;
    if (
      getProductByType(emailProducts, 'dental_ortho_buyup').Product.Business &&
      getProductByType(emailProducts, 'dental_ortho_buyup').Product.Business.Name
    ) {
      carrierName = getProductByType(emailProducts, 'dental_ortho_buyup').Product.Business.Name;
    }
    if (
      getProductByType(emailProducts, 'dental_ortho_buyup').Product.Business &&
      getProductByType(emailProducts, 'dental_ortho_buyup').Product.Business.LogoURL
    ) {
      carrierLogo = getProductByType(emailProducts, 'dental_ortho_buyup').Product.Business.LogoURL;
    }

    let buyupLogo = '';
    let buyupName = '';
    let hasBuyup = false;
    let coreName = '';
    if (getProductByType(emailProducts, 'dental_ortho_buyup').buyup) {
      hasBuyup = true;
      if (
        getProductByType(emailProducts, 'dental_ortho_buyup').buyup.Product &&
        getProductByType(emailProducts, 'dental_ortho_buyup').buyup.Product.ProductName
      ) {
        buyupName = getProductByType(emailProducts, 'dental_ortho_buyup').buyup.Product.ProductName;
      }

      if (
        getProductByType(emailProducts, 'dental_ortho_buyup').Product &&
        getProductByType(emailProducts, 'dental_ortho_buyup').Product.ProductName
      ) {
        coreName = getProductByType(emailProducts, 'dental_ortho_buyup').Product.ProductName;
      }

      if (
        getProductByType(emailProducts, 'dental_ortho_buyup').buyup.Product.Business &&
        getProductByType(emailProducts, 'dental_ortho_buyup').buyup.Product.Business.LogoURL
      ) {
        buyupLogo = getProductByType(emailProducts, 'dental_ortho_buyup').buyup.Product.Business.LogoURL;
      }
    }

    accountTemplate += benefitTemplate(
      'Dental Plus Orthodontics',
      carrierName,
      carrierLogo,
      false,
      '',
      hasBuyup,
      false,
      '',
      buyupLogo,
      buyupName,
      '',
      coreName
    );
  }
  if (emailRecList.shortTerm) {
    let carrierLogo = '';
    let carrierName = getProductByType(emailProducts, 'short_term_disability').Product.Carrier;
    if (
      getProductByType(emailProducts, 'short_term_disability').Product.Business &&
      getProductByType(emailProducts, 'short_term_disability').Product.Business.Name
    ) {
      carrierName = getProductByType(emailProducts, 'short_term_disability').Product.Business.Name;
    }
    if (
      getProductByType(emailProducts, 'short_term_disability').Product.Business &&
      getProductByType(emailProducts, 'short_term_disability').Product.Business.LogoURL
    ) {
      carrierLogo = getProductByType(emailProducts, 'short_term_disability').Product.Business.LogoURL;
    }

    let buyupLogo = '';
    let buyupName = '';
    let hasBuyup = false;
    let coreName = '';
    if (getProductByType(emailProducts, 'short_term_disability').buyup) {
      hasBuyup = true;
      if (
        getProductByType(emailProducts, 'short_term_disability').buyup.Product &&
        getProductByType(emailProducts, 'short_term_disability').buyup.Product.ProductName
      ) {
        buyupName = getProductByType(emailProducts, 'short_term_disability').buyup.Product.ProductName;
      }

      if (
        getProductByType(emailProducts, 'short_term_disability').Product &&
        getProductByType(emailProducts, 'short_term_disability').Product.ProductName
      ) {
        coreName = getProductByType(emailProducts, 'short_term_disability').Product.ProductName;
      }

      if (
        getProductByType(emailProducts, 'short_term_disability').buyup.Product.Business &&
        getProductByType(emailProducts, 'short_term_disability').buyup.Product.Business.LogoURL
      ) {
        buyupLogo = getProductByType(emailProducts, 'short_term_disability').buyup.Product.Business.LogoURL;
      }
    }
    accountTemplate += benefitTemplate(
      'Short-Term Disability',
      carrierName,
      carrierLogo,
      false,
      '',
      hasBuyup,
      false,
      '',
      buyupLogo,
      buyupName,
      '',
      coreName
    );
  }
  if (emailRecList.longTerm) {
    let carrierLogo = '';
    let carrierName = getProductByType(emailProducts, 'long_term_disability').Product.Carrier;
    if (
      getProductByType(emailProducts, 'long_term_disability').Product.Business &&
      getProductByType(emailProducts, 'long_term_disability').Product.Business.Name
    ) {
      carrierName = getProductByType(emailProducts, 'long_term_disability').Product.Business.Name;
    }
    if (
      getProductByType(emailProducts, 'long_term_disability').Product.Business &&
      getProductByType(emailProducts, 'long_term_disability').Product.Business.LogoURL
    ) {
      carrierLogo = getProductByType(emailProducts, 'long_term_disability').Product.Business.LogoURL;
    }

    let buyupLogo = '';
    let buyupName = '';
    let hasBuyup = false;
    let coreName = '';
    if (getProductByType(emailProducts, 'long_term_disability').buyup) {
      hasBuyup = true;
      if (
        getProductByType(emailProducts, 'long_term_disability').buyup.Product &&
        getProductByType(emailProducts, 'long_term_disability').buyup.Product.ProductName
      ) {
        buyupName = getProductByType(emailProducts, 'long_term_disability').buyup.Product.ProductName;
      }

      if (
        getProductByType(emailProducts, 'long_term_disability').Product &&
        getProductByType(emailProducts, 'long_term_disability').Product.ProductName
      ) {
        coreName = getProductByType(emailProducts, 'long_term_disability').Product.ProductName;
      }

      if (
        getProductByType(emailProducts, 'long_term_disability').buyup.Product.Business &&
        getProductByType(emailProducts, 'long_term_disability').buyup.Product.Business.LogoURL
      ) {
        buyupLogo = getProductByType(emailProducts, 'long_term_disability').buyup.Product.Business.LogoURL;
      }
    }

    accountTemplate += benefitTemplate(
      'Long-Term Disability',
      carrierName,
      carrierLogo,
      false,
      '',
      hasBuyup,
      false,
      '',
      buyupLogo,
      buyupName,
      '',
      coreName
    );
  }
  if (emailRecList.suppLife) {
    let carrierLogo = '';
    let carrierName = getProductByType(emailProducts, 'supplimental_life').Product.Carrier;
    if (
      getProductByType(emailProducts, 'supplimental_life').Product.Business &&
      getProductByType(emailProducts, 'supplimental_life').Product.Business.Name
    ) {
      carrierName = getProductByType(emailProducts, 'supplimental_life').Product.Business.Name;
    }
    if (
      getProductByType(emailProducts, 'supplimental_life').Product.Business &&
      getProductByType(emailProducts, 'supplimental_life').Product.Business.LogoURL
    ) {
      carrierLogo = getProductByType(emailProducts, 'supplimental_life').Product.Business.LogoURL;
    }
    accountTemplate += benefitTemplate('Supplemental Life Insurance', carrierName, carrierLogo);
  }

  accountTemplate += '</div>';

  return accountTemplate;
};

const getWorksiteBenefitTemplate = ({ emailRecList, emailProducts }) => {
  let accountTemplate = '<div>';
  if (emailRecList.critical || emailRecList.accidentPlan || emailRecList.cancer || emailRecList.hospital) {
    accountTemplate += `<h2> Supplemental Health Benefits</h2>`;
  }

  if (emailRecList.critical) {
    let carrierLogo = '';
    let carrierName = getProductByType(emailProducts, 'critical_illness').Product.CarrierName;
    if (
      getProductByType(emailProducts, 'critical_illness').Product.Business &&
      getProductByType(emailProducts, 'critical_illness').Product.Business.Name
    ) {
      carrierName = getProductByType(emailProducts, 'critical_illness').Product.Business.Name;
    }
    if (
      getProductByType(emailProducts, 'critical_illness').Product.Business &&
      getProductByType(emailProducts, 'critical_illness').Product.Business.LogoURL
    ) {
      carrierLogo = getProductByType(emailProducts, 'critical_illness').Product.Business.LogoURL;
    }
    let buyupLogo = '';
    let buyupName = '';
    let hasBuyup = false;
    let coreName = '';
    if (getProductByType(emailProducts, 'critical_illness').buyup) {
      hasBuyup = true;
      if (
        getProductByType(emailProducts, 'critical_illness').buyup.Product &&
        getProductByType(emailProducts, 'critical_illness').buyup.Product.ProductName
      ) {
        buyupName = getProductByType(emailProducts, 'critical_illness').buyup.Product.ProductName;
      }

      if (
        getProductByType(emailProducts, 'critical_illness').Product &&
        getProductByType(emailProducts, 'critical_illness').Product.ProductName
      ) {
        coreName = getProductByType(emailProducts, 'critical_illness').Product.ProductName;
      }

      if (
        getProductByType(emailProducts, 'critical_illness').buyup.Product.Business &&
        getProductByType(emailProducts, 'critical_illness').buyup.Product.Business.LogoURL
      ) {
        buyupLogo = getProductByType(emailProducts, 'critical_illness').buyup.Product.Business.LogoURL;
      }
    }

    accountTemplate += benefitTemplate(
      'Critical Illness',
      carrierName,
      carrierLogo,
      false,
      '',
      hasBuyup,
      false,
      '',
      buyupLogo,
      buyupName,
      '',
      coreName
    );
  }
  if (emailRecList.accidentPlan) {
    let carrierLogo = '';
    let carrierName = getProductByType(emailProducts, 'accident_plan').Product.Carrier;
    if (
      getProductByType(emailProducts, 'accident_plan').Product.Business &&
      getProductByType(emailProducts, 'accident_plan').Product.Business.Name
    ) {
      carrierName = getProductByType(emailProducts, 'accident_plan').Product.Business.Name;
    }
    if (
      getProductByType(emailProducts, 'accident_plan').Product.Business &&
      getProductByType(emailProducts, 'accident_plan').Product.Business.LogoURL
    ) {
      carrierLogo = getProductByType(emailProducts, 'accident_plan').Product.Business.LogoURL;
    }

    let buyupLogo = '';
    let buyupName = '';
    let hasBuyup = false;
    let coreName = '';
    if (getProductByType(emailProducts, 'accident_plan').buyup) {
      hasBuyup = true;
      if (
        getProductByType(emailProducts, 'accident_plan').buyup.Product &&
        getProductByType(emailProducts, 'accident_plan').buyup.Product.ProductName
      ) {
        buyupName = getProductByType(emailProducts, 'accident_plan').buyup.Product.ProductName;
      }

      if (
        getProductByType(emailProducts, 'accident_plan').Product &&
        getProductByType(emailProducts, 'accident_plan').Product.ProductName
      ) {
        coreName = getProductByType(emailProducts, 'accident_plan').Product.ProductName;
      }

      if (
        getProductByType(emailProducts, 'accident_plan').buyup.Product.Business &&
        getProductByType(emailProducts, 'accident_plan').buyup.Product.Business.LogoURL
      ) {
        buyupLogo = getProductByType(emailProducts, 'accident_plan').buyup.Product.Business.LogoURL;
      }
    }
    accountTemplate += benefitTemplate(
      'Accident',
      carrierName,
      carrierLogo,
      false,
      '',
      hasBuyup,
      false,
      '',
      buyupLogo,
      buyupName,
      '',
      coreName
    );
  }
  if (emailRecList.cancer) {
    let carrierLogo = '';
    let carrierName = getProductByType(emailProducts, 'cancer_buyup').Product.Carrier;
    if (
      getProductByType(emailProducts, 'cancer_buyup').Product.Business &&
      getProductByType(emailProducts, 'cancer_buyup').Product.Business.Name
    ) {
      carrierName = getProductByType(emailProducts, 'cancer_buyup').Product.Business.Name;
    }
    if (
      getProductByType(emailProducts, 'cancer_buyup').Product.Business &&
      getProductByType(emailProducts, 'cancer_buyup').Product.Business.LogoURL
    ) {
      carrierLogo = getProductByType(emailProducts, 'cancer_buyup').Product.Business.LogoURL;
    }
    accountTemplate += benefitTemplate('Cancer', carrierName, carrierLogo);
  }
  if (emailRecList.hospital) {
    let carrierLogo = '';
    let carrierName = getProductByType(emailProducts, 'hospital_indemnity').Product.Carrier;
    if (
      getProductByType(emailProducts, 'hospital_indemnity').Product.Business &&
      getProductByType(emailProducts, 'hospital_indemnity').Product.Business.Name
    ) {
      carrierName = getProductByType(emailProducts, 'hospital_indemnity').Product.Business.Name;
    }
    if (
      getProductByType(emailProducts, 'hospital_indemnity').Product.Business &&
      getProductByType(emailProducts, 'hospital_indemnity').Product.Business.LogoURL
    ) {
      carrierLogo = getProductByType(emailProducts, 'hospital_indemnity').Product.Business.LogoURL;
    }

    let buyupLogo = '';
    let buyupName = '';
    let hasBuyup = false;
    let coreName = '';
    if (getProductByType(emailProducts, 'hospital_indemnity').buyup) {
      hasBuyup = true;
      if (
        getProductByType(emailProducts, 'hospital_indemnity').buyup.Product &&
        getProductByType(emailProducts, 'hospital_indemnity').buyup.Product.ProductName
      ) {
        buyupName = getProductByType(emailProducts, 'hospital_indemnity').buyup.Product.ProductName;
      }

      if (
        getProductByType(emailProducts, 'hospital_indemnity').Product &&
        getProductByType(emailProducts, 'hospital_indemnity').Product.ProductName
      ) {
        coreName = getProductByType(emailProducts, 'hospital_indemnity').Product.ProductName;
      }

      if (
        getProductByType(emailProducts, 'hospital_indemnity').buyup.Product.Business &&
        getProductByType(emailProducts, 'hospital_indemnity').buyup.Product.Business.LogoURL
      ) {
        buyupLogo = getProductByType(emailProducts, 'hospital_indemnity').buyup.Product.Business.LogoURL;
      }
    }
    accountTemplate += benefitTemplate(
      'Hospital Indemnity',
      carrierName,
      carrierLogo,
      false,
      '',
      hasBuyup,
      false,
      '',
      buyupLogo,
      buyupName,
      '',
      coreName
    );
  }

  accountTemplate += '</div>';
  return accountTemplate;
};

const getCustomBenefitTemplate = ({ recommendedCustomProducts }) => {
  let accountTemplate = '<div>';
  if (recommendedCustomProducts.length > 0) {
    accountTemplate += `<h2> Other Benefits</h2>`;
  }

  for (let product of recommendedCustomProducts) {
    let carrierLogo = product.LogoURL;
    let carrierName = product.ProviderName;

    accountTemplate += benefitTemplate(
      product.Title,
      carrierName,
      carrierLogo,
      product.CallToActionUrl || '',
      product.CallToActionText || ''
    );
  }

  accountTemplate += '</div>';
  return accountTemplate;
};

const mapTypes = {
  dental_buyup: 'dental',
  dental_ortho_buyup: 'dentalOrtho',
  vision_buyup: 'vision',
  long_term_disability: 'longTerm',
  short_term_disability: 'shortTerm',
  supplimental_life: 'suppLife',
  accident_plan: 'accidentPlan',
  hospital_indemnity: 'hospital',
  cancer_buyup: 'cancer',
  critical_illness: 'critical',
};

export const getHtmlBody = (emailProps) => {
  const emailList = emailProps.emailRecList.selected.reduce((prev, item) => ({ ...prev, [mapTypes[item]]: true }), {});

  emailProps.emailRecList = {
    ...emailProps.emailRecList,
    ...emailList,
  };

  try {
    const emailBody = `
      <div style="width: 560px; margin: 0 auto;">
        ${getContactInfo(emailProps)}
        ${getMedicalPlanEmailTemplate(emailProps)}
        ${getCoreBenefitTemplate(emailProps)}
        ${getWorksiteBenefitTemplate(emailProps)}
        ${getCustomBenefitTemplate(emailProps)}
      </div>
    `;
    return emailBody;
  } catch (err) {
    console.log(err);
    return '';
  }
};
